var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup-notification-template',{attrs:{"messages":_vm.messages},on:{"send-report":_vm.onSendReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }